<script lang="ts">
  import NavBackLink from "../NavBackLink/NavBackLink.svelte";
  import { _ } from "svelte-i18n";
  import NavLinkListSM from "../NavLinkListSM/NavLinkListSM.svelte";
  import Link from "$lib/components/Link/Link.svelte";
  import { createEventDispatcher } from "svelte";
  import type { Nav, NavItem } from "$lib/gql/genCms/codegen";
  import RegionSelectorCTA from "$lib/components/Footer/RegionSelectorCTA/RegionSelectorCTA.svelte";

  export let nav: Nav;
  export let language = "";
  export let country = "";
  export let dark: boolean = false;

  let currentRoute: NavItem | false = false;
  let routeHistory: NavItem[] = [];

  const selectRoute = (e: any) => {
    if (currentRoute) {
      routeHistory.push(currentRoute);
    }
    currentRoute = e.detail;
  };

  const selectHistoryRoute = (e: any) => {
    if (!e.detail) {
      currentRoute = false;
      routeHistory = [];
    } else {
      currentRoute = e.detail;
      routeHistory = routeHistory.filter(value => value !== e.detail);
    }
  };

  const dispatch = createEventDispatcher();

  const closeNav = () => {
    dispatch("toggleMobileNav");
  };
</script>

<style lang="scss">
  .mobile-nav {
    background: $surface;
    width: 100%;
    max-width: 100vw;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    color: $on-surface;

    &--menu {
      flex: 1 1 0;
      position: relative;
      margin-bottom: 100px;

      &_wrapper {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 0 32px 76px;
        margin-bottom: 76px;
      }
    }

    &--breadcrumbs {
      display: flex;
      align-items: center;
      padding: 48px 32px 32px;
      min-height: 66px;
      flex: 0 1 auto;
      border-top: 1px solid $background;

      &--light {
        border-top: 1px solid $background;
      }

      &__link {
        &:not(:last-child) {
          border-right: 1px solid $inverse-on-surface-30;
          margin-right: 12px;
          padding-right: 12px;
        }
      }
    }

    &--account {
      display: flex;
      position: fixed;
      justify-content: space-between;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 4px 32px 48px;
      background: $surface;
      border: 1px solid $background;
      border-top: 0;

      &_wrapper {
        display: inline-block;
      }

      @include retina {
        border: 0.5px solid $background;
        border-top: 0;
      }
    }
  }

  @include breakpoint(md) {
    .mobile-nav {
      &--account {
        padding: 0 32px 64px;
      }
    }
  }
</style>

<div class="mobile-nav">
  <div
    class="mobile-nav--breadcrumbs {!dark
      ? 'mobile-nav--breadcrumbs--light'
      : ''}"
  >
    <div class="mobile-nav--breadcrumbs__link">
      {#if currentRoute && routeHistory.length === 0}
        <NavBackLink
          label={currentRoute.title}
          navItem={false}
          on:historySelect={selectHistoryRoute}
        />
      {:else if currentRoute && routeHistory.length > 0}
        {#each routeHistory as routeHistoryItem}
          <NavBackLink
            label={currentRoute.title}
            navItem={routeHistoryItem}
            on:historySelect={selectHistoryRoute}
          />
        {/each}
      {/if}
    </div>
  </div>
  <div class="mobile-nav--menu">
    <div class="mobile-nav--menu_wrapper">
      {#if nav && nav.items}
        {#if currentRoute}
          <NavLinkListSM
            on:routeSelect={selectRoute}
            on:toggleMobileNav
            navItems={currentRoute.items}
            viewAllPath={currentRoute.fullPath && currentRoute.items !== null
              ? currentRoute.fullPath
              : ""}
            promoImage={currentRoute.promoimage && currentRoute.promoimage.image
              ? currentRoute.promoimage
              : null}
          />
        {:else}
          <NavLinkListSM
            on:routeSelect={selectRoute}
            on:toggleMobileNav
            navItems={nav.items}
            primaryRoute={true}
            promoImage={null}
          />
        {/if}
      {/if}
    </div>
  </div>
  <div class="mobile-nav--account">
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
      class="mobile-nav--account_wrapper"
      on:click={closeNav}
      on:keydown={closeNav}
    >
      <Link icon="person" text="Account" href="account" theme="on-surface" />
    </div>
    <RegionSelectorCTA {language} {country} />
  </div>
</div>
